import { Flex } from '@chakra-ui/react';
import { FormFieldRadio } from '@publishing-engine/domain/types/article';
import React, { useState } from 'react';
import RadioUpdateModal from './RadioUpdateModal';
import { FieldHeader } from '../common/FieldHeader';
import { RadioEmptyState } from './RadioEmptyState';
import { RadioDisplay } from './RadioDisplay';
import { RadioDiffModal } from './RadioDiffModal';
import { EntryPoint } from 'src/utils/types';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';

export type RadioField = FormFieldRadio;

type IProps = {
  formFieldDefinition: RadioField;
  value: string;
  previousValue?: string | null;
  onChange?: (value: string) => void;
  entryPoint: EntryPoint;
  customCopies?: {
    fieldLabel?: string;
    diffModalTitle?: string;
  };
  isUpdateRequired?:boolean;
};

export const GenericRadioField: React.FC<IProps> = ({
  formFieldDefinition,
  value,
  previousValue,
  onChange,
  entryPoint,
  customCopies,
  isUpdateRequired
}) => {
  const { checkFormFieldValueIsUpdated } = useSubmissionFields(entryPoint);

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [showDiffModal, setShowDiffModal] = useState<boolean>(false);
  const openDiffModal = () => setShowDiffModal(true);
  const closeDiffModal = () => setShowDiffModal(false);
  const isEditable = !!onChange;

  const editCallback = isEditable
    ? () => {
        setIsEditing(true);
      }
    : undefined;

  const isUpdated = checkFormFieldValueIsUpdated(formFieldDefinition.name);
  const options = value
    ? formFieldDefinition.params.labels.options[value]
    : null;

  return (
    <Flex flexDirection={'column'} gap={2}>
      {isEditing && onChange && (
        <RadioUpdateModal
          formField={formFieldDefinition}
          isOpen={isEditing}
          onCancel={() => {
            setIsEditing(false);
          }}
          value={value}
          onSubmit={(value: string) => {
            setIsEditing(false);
            onChange(value);
          }}
          customCopies={{
            fieldLabel: customCopies?.fieldLabel
          }}
        />
      )}
      {isUpdated && showDiffModal ? (
        <RadioDiffModal
          fieldName={
            customCopies?.diffModalTitle ||
            formFieldDefinition.params.labels.main
          }
          value={value}
          previousValue={previousValue}
          onClose={closeDiffModal}
        />
      ) : null}
      <FieldHeader
        {...formFieldDefinition}
        label={
          customCopies?.fieldLabel || formFieldDefinition.params.labels.main
        }
        isUpdated={isUpdated}
        editCallback={editCallback}
        onShowDiffModal={openDiffModal}
        entryPoint={entryPoint}
        isUpdateRequired={isUpdateRequired}
      />
      {value ? (
        <RadioDisplay
          value={options?.main || value}
          subtitle={options?.secondary}
        />
      ) : (
        <RadioEmptyState />
      )}
    </Flex>
  );
};
